import { render, staticRenderFns } from "./UcRentalFormFixedAssets.yaml?vue&type=template&id=b8883142&component"
import script from "./UcRentalFormFixedAssets.yaml?vue&type=script&lang=ts&component"
export * from "./UcRentalFormFixedAssets.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports